import { Layout } from 'antd';
import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import AppHeader from './Header';

const { Content } = Layout;

export default function AdminLayout({ routes }) {
  const [collapsed, setCollapsed] = useState(false);

  return (
    <Layout className="admin-layout">
      <Sidebar routes={routes} collapsed={collapsed} onCollapse={setCollapsed} />
      <Layout className="admin-layout__main">
        <AppHeader />
        <Content className="app-content">
          <div className="route-fade">
            <Outlet />
          </div>
        </Content>
      </Layout>
    </Layout>
  );
}
